/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ForgotPasswordContainer_viewer = {
    readonly email: string | null;
    readonly " $refType": "ForgotPasswordContainer_viewer";
};
export type ForgotPasswordContainer_viewer$data = ForgotPasswordContainer_viewer;
export type ForgotPasswordContainer_viewer$key = {
    readonly " $data"?: ForgotPasswordContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ForgotPasswordContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPasswordContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '361897c0d1b1777192b89e4375e80801';
export default node;
